export default __webpack_public_path__ + "static/media/icon-coin-zeta.1955d4c9.svg";